'use client'

import { PropsWithChildren } from 'react'

import styles from './FooterCard.module.scss'

interface FooterCardProps extends PropsWithChildren {
  label: string
}

export function FooterCard({ label, children }: FooterCardProps) {
  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title}>{label}</h3>
      <div className={styles.content}>{children}</div>
    </div>
  )
}
